import React from 'react'
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import TenderCompletionNotDivided from "./TenderCompletionNotDivided";
import TenderCompletionDivided from "./TenderCompletionDivided";


function TenderCompletionData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const partialOffers = gVal("form.orderObject.partialOffers", false)

    return (<>

        <Collapse in={partialOffers === false} unmountOnExit>
            <TenderCompletionNotDivided id={gId("notDivided")} formikProps={formikProps} />
        </Collapse>

        <Collapse in={partialOffers === true} unmountOnExit>
            <TenderCompletionDivided id={id} formikProps={formikProps}/>
        </Collapse>

    </>)
}

TenderCompletionData.propTypes = {};

export default TenderCompletionData;
